module.exports = __webpack_public_path__ + "static/profileAnneli-63ed7f9134f782752103b2940c4d0d24.jpg";